import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@blocs.i18n';
import Row from '@minecraft.row';
import Container from '@minecraft.container';
import { Link } from 'react-router-dom';

const CenteredRow = styled(Row)`
  justify-content: center;
`;

const ErrorCode = styled.p`
  font-size: 6.25rem;
  color: ${(props) => props.theme.colors.primary.grey1};
  line-height: normal;
  margin: 2.5rem 0 0.625rem 0;
`;

const Description = styled.p`
  font-size: 1.25rem;
  font-weight: 200;
  text-align: center;
  color: ${(props) => props.theme.colors.primary.darkGrey};
  line-height: normal;
  margin: 0 0 1.25rem 0;
`;

const HomePageLink = styled(Link)`
  font-size: 1.15rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.primary.primary};
`;

interface NotFoundProps {
  redirectTo?: string;
  description?: string;
}

const NotFound: FC<NotFoundProps> = (props) => {
  const { t } = useTranslation();

  const { redirectTo = '/', description = t('common:notFound.description') } = props;

  return (
    <Container fluid data-testid="not-found-wrap">
      <CenteredRow>
        <ErrorCode>404</ErrorCode>
      </CenteredRow>
      <CenteredRow>
        <Description>{description}</Description>
      </CenteredRow>
      <CenteredRow>
        <HomePageLink to={redirectTo}>{t('common:notFound.goToHomePage')}</HomePageLink>
      </CenteredRow>
    </Container>
  );
};

export default NotFound;
